import React, { useEffect, useState } from 'react';
import withReactContent from 'sweetalert2-react-content';
import coordinatorprofileStyle from './CoordinatorAuthorProfilePage.module.css'
import { LuPencilLine } from "react-icons/lu";
import Swal from "sweetalert2";
import { LuPlus } from "react-icons/lu";
import { FiTrash2 } from "react-icons/fi";
import MainHeader from '../../components/mainheader/MainHeader'
import FormheadMobil from '../../components/formheadmobilComponent/formheadMobil'
import AuthorprofileInfo from '../../components/authorprofileComponent/authorprofileInfo'
import ContactInfo from '../../components/contactComponent/contactInfo'
import MoreInfo from '../../components/moreinfoComponent/moreInfo'
import BiographyInfo from '../../components/biographyComponent/biographyInfo'
import BooklistInfo from '../../components/booklistComponent/booklistInfo'
import NotetoaudienceInfo from '../../components/notetoaudienceComponent/notetoaudienceInfo'
import NotetohostInfo from '../../components/notetohostComponent/notetohostInfo'
import FormHead from '../../components/formheadComponent/formHead'
import { useMediaQuery } from 'react-responsive';
import { useParams } from "react-router-dom";
import axios from "axios";
require('typeface-poppins')

export default function CoordinatorAuthorProfilePage() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const MySwal = withReactContent(Swal);
    const [expanded, setExpanded] = useState(false);
    let delrec = Array();
    let nji = Array();
    const [availableBooks, setAvailableBooks] = useState([]);
    const { id } = useParams();
    const [proimage, setProimage] = useState('')
    const [authorsbook, setBooks] = useState([]);
    const [user, setUser] = useState(null); // State to hold user details
    const [category1, setCategory1] = useState('');
    const [genre1, setGenre1] = useState('');
    const [region1, setRegion1] = useState('');
    const [error, setError] = useState(null); // State to handle errors
    const [loading, setLoading] = useState(true);

    /* const visibleBooks = expanded
      ? authorsbook
      : authorsbook.slice(0, 3); */
    const visibleBooks = authorsbook;

    useEffect(() => {
        // Fetch user details from the backend
        const fetchUserDetails = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data.php?id=${id}`);
                if (response.data.success) {

                    setProimage(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${id}.jpg`);

                    setUser(response.data.user);
                    setBooks(response.data.authorsbook);
                    setGenre1(response.data.genres);
                    setRegion1(response.data.regions);
                    setCategory1(response.data.categories);
                } else {
                    setError(response.data.message);
                }
            } catch (err) {
                setError("Failed to fetch user details. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
        fetchUserDetails();
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    // BooklistISBN Component        
    function BooklistIsbn() {

        const [count3, setCount3] = useState([]);
        const [count2, setCount2] = useState([]);
        const [count1, setCount1] = useState(null); // Store book data here
        const [inputValue, setInputValue] = useState('');

        const handleInputChange = (event) => {
            setInputValue(event.target.value);
        };
        const handleSearchClick22 = async (idd) => {

            const element = document.getElementById(idd);
            if (element) {
                delrec.push(idd);
                element.style.display = 'none';
                // console.log(delrec);
            }
        }

        const handleSearchClick = async () => {
            if (inputValue !== undefined && inputValue !== '') {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/getbook.php?isbn=${inputValue}`);
                    //console.log(response, 'Response');
                    if (response.data.success) {

                        // Format the response data into a table format
                        const bookDetails = response.data.bookdetails;

                        setCount1(
                            <table className={`${coordinatorprofileStyle.resultTablebooklist} table table-borderless`}>
                                <thead>
                                    <tr>
                                        <th className='w-50 text-start'>Title</th>
                                        <th className='w-25'>Price</th>
                                        <th className='w-25'>Add</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='w-50 text-start'>{bookDetails.TITLE[0]}</td>
                                        <td className='w-25'>$ {bookDetails.PRICE[0]}</td>
                                        <td className='w-25'>
                                            <button className={`${coordinatorprofileStyle.plusButtonbooklist} btn btn-primary`} onClick={() => handlePlusButtonClick(bookDetails.ISBN[0], bookDetails.TITLE[0], bookDetails.PRICE[0], id)}>
                                                <LuPlus className={coordinatorprofileStyle.plusIconbooklist} />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        );

                    } else {
                        setCount1(<p>No record found</p>);
                        alert(response.data.message);
                    }
                } catch (err) {
                    alert(err);
                }
            }
        };
        const handlePlusButtonClick = async (isbn, title, price, id) => {

            const exists = authorsbook.some(book => book.isbn === isbn);
            if (exists && !(delrec.includes(isbn))) {


                alert("This book is already added.");
                return;
            }

            const exists1 = nji.some(book => book.isbn === isbn);

            if (exists1 && !(delrec.includes(isbn))) {

                alert("This book is already added.");
                return;
            }

            if (delrec.includes(isbn)) {

                delrec = delrec.filter(item => item !== isbn);

            }

            const newBook = { isbn, title, price };
            nji.push(newBook);

            setCount3(prevCount3 => [
                ...prevCount3,
                { isbn, title, price }
            ]);


            setCount2(
                prevCount2 => [
                    ...prevCount2.reverse(),
                    <tr id={isbn}>
                        <td>{title}</td>
                        <td>{isbn}</td>
                        <td>$ {price}</td>
                        <td className='text-center' onClick={() => handleSearchClick22(`${isbn}`)}><FiTrash2 className='trashicon' /></td>
                    </tr>
                ]
            );
            setCount1(null);
            setInputValue('');

        };
        return (
            <>
                <div className='row'>
                    <div className='col-lg-8'>
                        <div className="d-flex mb-3">
                            <input type="text" className={`${coordinatorprofileStyle.searchInputbooklist} form-control rounded-0`} value={inputValue} onChange={handleInputChange} placeholder="Enter ISBN" />
                            <button onClick={handleSearchClick} className={`${coordinatorprofileStyle.searchBtnbooklist} btn btn-danger rounded-0`} style={{ width: '30%' }}>
                                Search
                            </button>
                        </div>
                        <div className={coordinatorprofileStyle.findBooksResultsbooklist}>
                            <div className="table-responsive">
                                {count1}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className={`${coordinatorprofileStyle.tablelist}`}>
                            <div className='table-responsive'>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th style={{ width: '150px' }}>ISBN</th>
                                            <th style={{ width: '100px' }}>Price</th>
                                            <th className='text-center' style={{ width: '100px' }}>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {count2}
                                        {visibleBooks.map((book, index) => (
                                            <tr key={index} id={book.isbn}>
                                                <td>{book.title}</td>
                                                <td>{book.isbn}</td>
                                                <td>$ {book.price}</td>
                                                <td className='text-center' onClick={() => handleSearchClick22(`${book.isbn}`)}>
                                                    <FiTrash2 className={coordinatorprofileStyle.booklisttrashIcon} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // BookList popup
    const bookListpop = async () => {
        const { value: formData } = await MySwal.fire({
            title: `My Books: ${user.f_name} ${user.l_name}`,
            html: (
                <div className='bookListpopup'>
                    <div className='container'>
                        <BooklistIsbn />
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${coordinatorprofileStyle.mainbooklistPopup}`,
                title: `${coordinatorprofileStyle.mainbooklistTitle}`,
                confirmButton: `${coordinatorprofileStyle.mainbooklistsaveButton}`,
                closeButton: `${coordinatorprofileStyle.mainbooklistcloseButton}`,
                cancelButton: `${coordinatorprofileStyle.mainbooklistcancelbutton}`,
            },
            preConfirm: async () => {
                // Check if either `nji` or `delrec` is not empty
                if (nji.length > 0 || delrec.length > 0) {
                    try {
                        // Make the POST request to the API
                        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/addbookstoauthor.php`, {
                            add: nji,  // The books to be added
                            del: delrec,  // The books to be removed
                            auid: id  // Author ID
                        });

                        // Check the API response
                        if (response.data.success) {
                            //alert('Books successfully added or removed.');
                            // You can handle any further logic on success here
                            await MySwal.fire({
                                icon: 'success',
                                title: 'Books successfully added or removed!',
                                showConfirmButton: false,
                                timer: 2000, // auto-close after 2 seconds
                            });
                            window.location.reload();
                        } else {
                            alert('Failed to add or remove books.');
                        }
                    } catch (err) {
                        // Handle any errors that occur during the API request
                        alert('Error adding or removing books. Please try again.');
                        console.error(err);
                    }
                } else {
                    // Alert when no changes are made
                    alert('Please add or remove books before saving.');
                }
            },
        });
        // if (formData) {
        //     console.log('Registration data:', formData);
        // }
    };

    return (
        <>
            <MainHeader />
            <div className={coordinatorprofileStyle.mainauthorprofilepage}>

                {isMobile ? (
                    <div className={coordinatorprofileStyle.mobilauthorprofiletopbar}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <FormheadMobil />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={coordinatorprofileStyle.desktopauthorprofiletopbar}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <FormHead />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {isMobile ? (
                    <div className={coordinatorprofileStyle.mobilmainprofileContent}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-xl-12 col-xxl-12'>
                                    <AuthorprofileInfo mobilImg={proimage} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <ContactInfo fName={user.f_name} lName={user.l_name} cMail={user.email_id} cMobil={user.phone} web={user.website} zip={user.zipcode} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <MoreInfo region={user.region} category={user.category} willing={user.willingtotravel ? 'yes' : 'No'} genre={user.genre}
                                        authorIllu={user.authororillustrator === 0 ? 'Author' : user.authororillustrator === 1 ? 'Illustrator' : 'Author & Illustrator'} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <BiographyInfo bio={user.biography} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <BooklistInfo authorbookdata={authorsbook} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <NotetoaudienceInfo noteFamily={user.notetofamilies} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <NotetohostInfo noteHost={user.notetohost} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (

                    <div className={coordinatorprofileStyle.desktopmainprofileContent}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-xl-4 col-xxl-4'>
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className={coordinatorprofileStyle.authorprofileBox}>
                                                <div className={coordinatorprofileStyle.authorprofilePreview}>
                                                    <div className={coordinatorprofileStyle.authorprofileimageWrap}>
                                                        <img src={proimage} className='img-fluid w-100 h-100' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className={coordinatorprofileStyle.authorcontactinfoBox}>
                                                <h4>Contact Info</h4>
                                                <div className={coordinatorprofileStyle.authorinfobox}>
                                                    <h5>Name</h5>
                                                    <p>{user.f_name} {user.l_name}</p>
                                                </div>
                                                <div className={coordinatorprofileStyle.authorinfobox}>
                                                    <h5>Website</h5>
                                                    <a href='https://www.authormeet.net/' target="_blank">{user.website}</a>
                                                </div>
                                                <div className={coordinatorprofileStyle.authorinfobox}>
                                                    <h5>Email Address</h5>
                                                    <p>{user.email_id}</p>
                                                </div>
                                                <div className={coordinatorprofileStyle.authorinfobox}>
                                                    <h5>Phone</h5>
                                                    <p>{user.phone}</p>
                                                </div>
                                                <div className={`${coordinatorprofileStyle.authorinfobox} pb-0`}>
                                                    <h5>Hometown Zip Code</h5>
                                                    <p>{user.zipcode}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mb-4'>
                                        <div className="col-xl-12">
                                            <div className={coordinatorprofileStyle.authormoreinfoBox}>
                                                <h4>More Info</h4>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Willing to Travel?</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.willingtotravel ? 'yes' : 'No'}</p>
                                                    </div>
                                                </div>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Region</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.region}</p>
                                                    </div>
                                                </div>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Category</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.category}</p>
                                                    </div>
                                                </div>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Genre</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.genre}</p>
                                                    </div>
                                                </div>
                                                <div className='row align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Author or Illustrator</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.authororillustrator === 0 ? 'Author' :
                                                            user.authororillustrator === 1 ? 'Illustrator' :
                                                                'Author & Illustrator'}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-xl-8 col-xxl-8'>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={coordinatorprofileStyle.authorBiographybox}>
                                                <h5>Biography</h5>
                                                <p>{user.biography}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={coordinatorprofileStyle.authorbooklistBox}>
                                                <div className={coordinatorprofileStyle.authorbookheaderBox}>
                                                    <h4>Book List</h4>
                                                    <button className={`${coordinatorprofileStyle.editButtonn} btn btn-light`} onClick={bookListpop}>Edit
                                                        <LuPencilLine className={`${coordinatorprofileStyle.editButtonicon} ms-1`} />
                                                    </button>
                                                </div>
                                                <div className={coordinatorprofileStyle.authorbookbodyBox}>
                                                    <div className='table-responsive'>
                                                        <table className={`${coordinatorprofileStyle.authorbooklistTable} table table-borderless`}>
                                                            <thead>
                                                                <tr>
                                                                    <th class={`w-50`}>Title</th>
                                                                    <th>ISBN</th>
                                                                    <th className='text-end'>Price</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {authorsbook.map((book, index) => (
                                                                    <tr key={index}>
                                                                        <td class={`w-50`}>{book.title}</td>
                                                                        <td>{book.isbn}</td>
                                                                        <td className='text-end'>${book.price}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={coordinatorprofileStyle.authornotetofamiliesBox}>
                                                <h5>Note to Audience</h5>
                                                <p>{user.notetofamilies}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={coordinatorprofileStyle.authornotetohostBox}>
                                                <h5>Note to Hosts</h5>
                                                <p className='pb-4'>{user.notetohost}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}